export function appendDateToString({
  title: title,
  location: location = '',
  locations: selectedLocations = [],
  showDate: showDate = true,
  showLocation: showLocation = true,
}) {
  let locationLabel: string;

  if (selectedLocations && selectedLocations.length > 1) {
    locationLabel = 'Multiple-Locations';
  } else if (selectedLocations.length === 1) {
    locationLabel = selectedLocations[0].name;
  } else {
    locationLabel = location || 'All-Locations';
  }

  locationLabel = locationLabel.replace(' ', '-');

  const d = new Date();
  let filename = title;

  if (showLocation) {
    filename += '-' + locationLabel;
  }

  if (showDate) {
    filename +=
      '-' +
      d.getHours().toString().padStart(2, '0') +
      '-' +
      d.getMinutes().toString().padStart(2, '0') +
      '-' +
      d.getSeconds().toString().padStart(2, '0') +
      '-' +
      d.getDate().toString().padStart(2, '0') +
      '-' +
      (d.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      d.getFullYear();
  }

  return filename;
}
